import { render } from "./CalendarComponent.vue?vue&type=template&id=4889c50d&scoped=true&ts=true"
import script from "./CalendarComponent.vue?vue&type=script&lang=ts"
export * from "./CalendarComponent.vue?vue&type=script&lang=ts"

import "./CalendarComponent.vue?vue&type=style&index=0&id=4889c50d&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/DangKyKB_HV/DKKB_new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4889c50d"]])

export default __exports__